import { Modal } from "@components/Modal";
import { useTranslation } from "@helpers/useTranslation";
import React, { FC, Suspense } from "react";

const EventBettingPoolInfographic = React.lazy(
  () => import("./Infographic")
);

type Props = {
  show: boolean;
  onClose: () => void;
};


export const HowBettingWorksModal: FC<Props> = ({ show, onClose }) => {
  const { t } = useTranslation("challenges");

  if (!show) return null;

  return (
    <Modal show={show} onCancel={onClose} className="z-50" size="xl">
      <div className="flex flex-col items-center space-y-4">
        <h3 className="text-center text-lg font-bold">{t("howBettingWorksTitle")}</h3>

        <div className="flex w-full justify-center">
          <Suspense fallback={<div className="p-6 text-sm text-slate-600">Loading…</div>}>
            <EventBettingPoolInfographic />
          </Suspense>
          {/* <img
            src="/how-betting-works.jpg"
            alt={t("howBettingWorksAlt")}
            className="h-auto max-w-full rounded-lg shadow-lg"
            style={{ maxHeight: "60vh" }}
          /> */}
        </div>

        <div className="flex justify-center pt-4">
          <button onClick={onClose} className="btn-primary btn px-8">
            {t("gotIt")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

